import SettingsGroup from "components/CRM/SettingsGroup";
import AppColorPicker from "elements/AppColorPicker";
import { FormGroup, Input } from "reactstrap";
import { TagInput } from "rsuite";

const NameDescriptionGroup = ({ widget, updateSection, theme }) => {
  const updateName = (e) => {
    const newName = e.target.value;
    updateSection("Name", newName);
  };

  const updateDescription = (e) => {
    const newDescription = e.target.value;
    updateSection("Description", newDescription);
  };

  const updateKeywords = (v) => {
    updateSection("AIKeywords", v);
  };

  return (
    <SettingsGroup title="Widget Information" className="mb-2">
      <FormGroup>
        <h5>Name</h5>
        <Input bsSize="sm" value={widget?.Name ?? ""} onChange={updateName} />
      </FormGroup>
      <FormGroup>
        <h5>Description</h5>
        <Input
          type="textarea"
          bsSize="sm"
          value={widget?.Description ?? ""}
          onChange={updateDescription}
        />
      </FormGroup>
      <FormGroup>
        <h5 className="m-0">Brie AI Keywords</h5>
        <p className="small text-muted">
          Keywords indexed by Brie AI to return intelligent responses from this
          widget
        </p>
        <TagInput
          size="md"
          block
          trigger={["Enter", "Comma"]}
          onChange={updateKeywords}
          value={widget?.AIKeywords ?? []}
        ></TagInput>
      </FormGroup>
      <hr className="my-3" />
      {/* Disabled for now */}
      {/* <LockWidthSetting section={widget} updateSection={updateSection} />
      <LockHeightSetting section={widget} updateSection={updateSection} /> */}
    </SettingsGroup>
  );
};

export default NameDescriptionGroup;
